import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8a4da8d4"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "calendar-section"
}
const _hoisted_2 = { class: "calendar-section__scroll" }
const _hoisted_3 = { class: "calendar-section__track" }
const _hoisted_4 = { class: "calendar-card__image-wrap" }
const _hoisted_5 = { class: "calendar-card__content" }
const _hoisted_6 = { class: "calendar-card__title" }
const _hoisted_7 = { class: "calendar-card__subtitle" }

import { computed } from "vue";
import { Image as VanImage } from "vant";
import type { HotspotJumpLinkItem } from "../model";


export default /*#__PURE__*/_defineComponent({
  __name: 'ActivityCalendar',
  props: {
    items: null
  },
  emits: ["open-app"],
  setup(__props: any, { emit }: { emit: ({
  (event: "open-app"): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  items: HotspotJumpLinkItem[];
}





const cardWidthClass = computed(() => {
  if (props.items.length <= 1) return "calendar-card--full";
  if (props.items.length === 2) return "calendar-card--half";
  return "calendar-card--third";
});

return (_ctx: any,_cache: any) => {
  return (__props.items.length)
    ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.items, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: item.jumpUrl || item.title || index,
                class: _normalizeClass(["calendar-card", _unref(cardWidthClass)]),
                onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('open-app')))
              }, [
                _createElementVNode("div", _hoisted_4, [
                  (item.image)
                    ? (_openBlock(), _createBlock(_unref(VanImage), {
                        key: 0,
                        fit: "cover",
                        class: "calendar-card__image",
                        src: item.image,
                        alt: item.title || '活动日历'
                      }, null, 8, ["src", "alt"]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, _toDisplayString(item.title), 1),
                  _createElementVNode("div", _hoisted_7, _toDisplayString(item.subTitle), 1)
                ])
              ], 2))
            }), 128))
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})